import React, { useRef } from 'react';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// css
import './Profiledetail.css'
import userProfile from '../../../Assets/images/user.png'
// register locale
countries.registerLocale(enLocale);

function getCountryNameFromCountryCode(countryCode, phone_number) {
  const formattedPhoneNumber = `${countryCode}${phone_number}`;
  const parsedNumber = parsePhoneNumberFromString(formattedPhoneNumber);
  if (parsedNumber && parsedNumber.isValid()) {
    const countryCode = parsedNumber.country;
    if (countryCode) {
      return countries.getName(countryCode, 'en');
    }
  }
  return null;
}

const Profiledetail = () => {
  const navigate = useNavigate();

  const profileData = useSelector((state) => state.auth.user?.data?.body?.data?.userData);

  const role_name = useSelector((state) => state.auth.user?.data?.body?.data?.role_name);
  const formattedRole = role_name
    .toLowerCase()               // "super_user"
    .replace(/_/g, "-");         // "super-user"

  const finalRole = formattedRole.charAt(0).toUpperCase() + formattedRole.slice(1);

  const counrtyname = getCountryNameFromCountryCode(profileData.country_code, profileData.phone_number);

  return (
    <div className='main-inner-block'>
      <div className='content'>
        <div className='white-box'>
          <div className='inner-content-blk'>
            <div className='listing-title-block d-flex justify-content-between pt-0 align-items-center'>
              <div className='box-listing-title profile_heading'>
                Profile Details
              </div>
              <div className='searchbar-btn d-flex align-items-center gap-4'>
                <div className='text-center mt-3 update-div d-flex align-items-center justify-content-center gap-2'>
                  <button
                    type="button"
                    class="green-btn editbtn"
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    class="green-btn editbtn"
                    onClick={() => navigate('/edit-user-profile')}
                  >
                    Edit
                  </button>
                </div>
              </div>
            </div>
            <div className='profile-details-box'>
              <div className='inner-profile-block d-flex gap-3 align-items-center'>
                <div className='profile-img'>
                  <img src={userProfile} alt="profile-pic"></img>
                </div>
                <div className='user-name'>{profileData.first_name} {profileData.last_name}<span className='designation-name'> ({finalRole})</span>
                  <span className='d-block mt-3 location'>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.00036 0C5.40581 0 2.48145 2.92437 2.48145 6.51888C2.48145 10.9798 8.31524 17.5287 8.56362 17.8053C8.79691 18.0651 9.20423 18.0647 9.43711 17.8053C9.68549 17.5287 15.5193 10.9798 15.5193 6.51888C15.5192 2.92437 12.5949 0 9.00036 0ZM9.00036 9.79871C7.19186 9.79871 5.72057 8.32739 5.72057 6.51888C5.72057 4.71037 7.19189 3.23909 9.00036 3.23909C10.8088 3.23909 12.2801 4.71041 12.2801 6.51892C12.2801 8.32743 10.8088 9.79871 9.00036 9.79871Z" fill="#777777" />
                    </svg>
                    <span className='country-name'>{counrtyname}</span>
                  </span>
                </div>
              </div>
            </div>
            <div className='profile-details-box content-info'>
              <div className='profile-box-area d-flex flex-wrap align-items-center'>
                <div className='profile-box'>
                  <label for="firstName" class="form-label m-0">First Name</label>
                  <div className='form-input-block'>{profileData.first_name}</div>
                </div>
                <div className='profile-box'>
                  <label for="lastName" class="form-label m-0">Last Name</label>
                  <div className='form-input-block'>{profileData.last_name}</div>
                </div>
                <div className='profile-box'>
                  <label for="firstName" class="form-label m-0">Work Email</label>
                  <div className='form-input-block text-break'>{profileData.email}</div>
                </div>
                <div className='profile-box'>
                  <label for="firstName" class="form-label m-0">Country</label>
                  <div className='form-input-block'>{counrtyname ? counrtyname : "-"}</div>
                </div>
                <div className='profile-box'>
                  <label for="firstName" class="form-label m-0">Contact no.</label>
                  <div className='form-input-block'>
                    {
                      profileData.country_code ?
                        (
                          <>
                            {profileData.country_code} {profileData.phone_number}
                          </>
                        ) :
                        "-"
                    }
                  </div>
                </div>

              </div>

            </div>
          </div>

        </div>

      </div>
    </div>
  )
}

export default Profiledetail